module.exports = __webpack_public_path__ + "img/BFAA83_F5EAD6_E1D0B1_EBDDC0-256px.292a5ca3.png";